export default {
  Starters: [
    'equal',
    'not',
    'is',
    'starts',
    'ends',
    'contains',
    'in',
    'greater',
    'between',
    'less'
  ],
  Operators: [
    'equal to',
    'not equal to',
    'is',
    'starts with',
    'ends with',
    'contains',
    'in',
    'not in',
    'greater than',
    'greater or equal to',
    'between',
    'less than',
    'less or equal to'
  ],
  OperatorsRequireValues: [
    'equal to',
    'not equal to',
    'is',
    'starts with',
    'ends with',
    'contains',
    'in',
    'not in',
    'greater than',
    'greater or equal to',
    'between',
    'less than',
    'less or equal to'
  ]
}
